<template>
  <div>
    <div id="chattool" class="text-xs-center">
      <v-tabs
        v-model="chattooltype"
        color="grey lighten-3"
        :slider-color="$vuetify.theme.primary"
        show-arrows
      >
        <v-tab ripple :key="'customer'" :href="'#customer'">{{ $t('Info') }}</v-tab>
      </v-tabs>
    </div>

    <div id="wrapperLivechat" style="overflow-y:auto; height: calc(100vh - 112px)">
      <!-- v-resize="onResizeToolList"
      :style="{ height: toolListHeight + 'px' }" -->
      <div v-if="chattooltype == 'customer'">
        <livechat-customers
          :pageid="$store.state.livechat.pageid"
          v-model="selectedUser"
          :key="`customer_detail_${selectedUser.userid}_${selectedUser.type}`"
        ></livechat-customers>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import LivechatCustomers from './livechat-customers'
import api from '@/api'

export default {
  props: ['selectedUser'],
  components: {
    LivechatCustomers,
  },
  data() {
    return {
      chattooltype: 'customer',
      toolListHeight: 0,
      allrentcustomer: [],
      allrentsupplier: []
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  mounted() {
    var vm = this
    if (this.selectedBot.theme == 'scgallrent') {
      vm.getallrenttransactionlivechat()
    }
    if (vm.selectedBot.theme == 'scgworkplace') {
      vm.chattooltype = 'workplacecustomer'
    }
    if (vm.selectedBot.theme == 'ticket') {
      vm.chattooltype = 'ticket'
    }
    vm.onResizeToolList()
  },
  methods: {
    getallrenttransactionlivechat() {
      if (this.selectedUser && this.selectedUser.userid) {
        var data = {
          pageid: this.$store.state.livechat.pageid,
          userid: this.selectedUser.userid
        }
        api.getallrenttransactionlivechat(data, (err, response) => {
          if (response.responsecode == 200) {
            this.allrentcustomer = response.data
            this.allrentsupplier = response.data2
          }
        })
      }
    },
    onResizeToolList: function() {
      var vm = this
      vm.$nextTick(function() {
        var toolListHeight = 0
        if (document.getElementById('chattool')) {
          toolListHeight = document.getElementById('chattool').clientHeight
        }
        vm.toolListHeight =
          window.innerHeight - document.getElementById('main_toolbar').clientHeight - toolListHeight
      })
    }
  },
  watch: {
    selectedUser: function(newVal, oldVal) {
      var vm = this
      if (newVal != oldVal) {
        if (this.selectedBot.theme == 'scgallrent') {
          vm.getallrenttransactionlivechat()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/livechat/livechat-chattool.vue